@if (helpTooltipKey) {
    <i class="fa fa-question-circle help-icon ms-3" aria-hidden="true" ngbTooltip="{{ helpTooltipKey | translate }}"></i>
} @else if (helpLink) {
    <a href="{{helpLink}}" target="_blank">
        <i class="fa fa-question-circle help-icon ms-3" aria-hidden="true" [ngbTooltip]="'global.click.to.open.help.link' | translate"></i>
    </a>
}
